export const EDITS_IMGIX_HOSTNAMES = new Set(['airdev-edits.imgix.net', 'air-edits.imgix.net']);

const LOCAL_EDITS_BUCKET_PATH_PREFIX = '/air-edits-local/';

const isLocaldev = (): boolean => process.env.NEXT_PUBLIC_LOCALDEV === 'true';

export function isFromEditsBucket(url: string | undefined): boolean {
  if (!url) {
    return false;
  }
  try {
    const parsed = new URL(url);

    if (EDITS_IMGIX_HOSTNAMES.has(parsed.hostname)) {
      return true;
    }

    return (
      isLocaldev() &&
      parsed.hostname === 'localhost' &&
      parsed.port === '4566' &&
      parsed.pathname.startsWith(LOCAL_EDITS_BUCKET_PATH_PREFIX)
    );
  } catch {
    return false;
  }
}
